import moment from 'moment'
import { sanitizeHtml, fetchThumbnailUrl, cropHtml } from "../utils/Feed";

function renderFeedItems(data, elem) {
    const isList = elem.hasClass('display-list');
    const characterLimit = elem.attr('data-character-limit');
    const postLimit = elem.attr('data-post-limit');

    data.entries.slice(0, parseInt(postLimit)).forEach(function(item) {
        const thumbnailUrl = isList ? null : item.thumbnail || fetchThumbnailUrl(item.content);
        const sanitizedContent = isList ? null : sanitizeHtml(item.content)
        const innerHTML = sanitizedContent ? cropHtml(sanitizedContent, characterLimit) : null

        let postsListItem = $('<div class="postlist-item"></div>');
        if (!isList && thumbnailUrl) {
            postsListItem.append('<div class="postlist-thumbnail" style="background-image: url(' + thumbnailUrl + ')" />')
        }
        if (!isList && !thumbnailUrl) {
            postsListItem.append('<div class="postlist-thumbnail thumbnail-notfound" />')
        }

        let itemContent = $('<div class="postlist-content"></div>')
        itemContent.append('<div class="postlist-title"><a href="' + item.link +'" target="_blank">'+item.title+'</a></div>')

        let authorTimeStamp = $('<div class="postlist-timestamp"></div>')
        let authorTimeStampText = item.author ? `by ${item.author}` : ''
        authorTimeStampText = item.author && item.timestamp ? authorTimeStampText + ' / ' : authorTimeStampText
        authorTimeStampText = item.timestamp ? authorTimeStampText + moment(item.timestamp * 1000).calendar() : authorTimeStampText

        authorTimeStamp.html(authorTimeStampText)
        itemContent.append(authorTimeStamp)

        if (innerHTML) {
            let itemDescription = $('<div class="postlist-description"/>')
            itemDescription.html(innerHTML)
            itemContent.append(itemDescription)
        }

        postsListItem.append(itemContent)
        elem.append(postsListItem);
    })
}

 function fetchFeedData(elem) {
    const feedURL = elem.attr('data-feed-url');
    if (!feedURL) {
        console.warn("No URL found for RSS feed element")
    }

    const bodyJSON = {
        "version": "1.1",
        "id": 1,
        "method": "get_rss_feed",
        "params": [
            {
                "url": feedURL
            }
        ]
    };

    $.ajax({
        url: '/rssparser',
        type: 'post',
        data: JSON.stringify(bodyJSON),
        dataType: 'json',
        cache: false,
        contentType: 'application/json',
        processData: false,
        success: function(data) {
            if (data && data.result) {
                renderFeedItems(data.result, elem)
            } else {
                console.warn("Failed to fetch feed data")
            }
        },
        error: function() {
            console.warn("Failed to fetch feed data")
        }
    })
};

export function renderFeed(elems) {
    elems.each(function() {
        const target = $(this);
        const feedData = fetchFeedData(target);
    });
}



// WEBPACK FOOTER //
// ./src/common/renderFeed.js